import { DetailWrapper } from "../../../../../features/ui"
import { TaxDetail } from "./taxDetail"

export const TaxDetailLoader = () => (
    <DetailWrapper>
        <TaxDetail />
    </DetailWrapper>
)
